import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-heading" }
const _hoisted_2 = { class: "menu-heading-icon" }
const _hoisted_3 = { class: "flex-1 ellipsis" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" delete page ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" copy mention ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "",
    ref: "content",
    onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
    tabindex: "0"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx._page.icon), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx._page.name), 1)
    ]),
    _createElementVNode("div", {
      class: "menu-item hover:bg-warm cursor-pointer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deletePage && _ctx.deletePage(...args))),
      tabindex: "0"
    }, [
      _createVNode(_component_Icon, {
        icon: ['fal', 'trash-alt'],
        class: "icon-sm"
      }),
      _hoisted_4
    ]),
    _createElementVNode("div", {
      class: "menu-item hover:bg-warm cursor-pointer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyMention && _ctx.copyMention(...args))),
      tabindex: "0"
    }, [
      _createVNode(_component_Icon, {
        icon: ['fal', 'copy'],
        class: "icon-sm"
      }),
      _hoisted_5
    ])
  ], 544))
}